import { UnitedStatesPurchaseTaxes } from '..'

export const IllinoisPurchaseTaxes = { ...UnitedStatesPurchaseTaxes }
